/* eslint-disable */
import { useEffect } from "react";
import Header from "components/Common/Header/Header";
import EventAgendaBody from "components/EventComponents/EventDetailsComponents/EventAgenda/AgendaBody/EventAgendaBody";

const EventAgenda = () => {
  useEffect(() => {
    document.title = "Event Agenda";
  }, []);

  return (
    <>
      <main id="app">
        {/* ---- header start ---- */}
        <Header moduleName="events" />
        {/* --- header end --- */}
        <EventAgendaBody />
      </main>
    </>
  );
};

export default EventAgenda;
